import { ReactNode } from "react";
import styled from "styled-components";
import { alpha } from "../../../typography";

const StyledContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  ${alpha.primaryActive.body3};
`;

type ContentProps = {
  children: ReactNode;
};

export const Content = ({ children }: ContentProps) => {
  return <StyledContent>{children}</StyledContent>;
};
